const items = new Map()

items.set('privacy', ctx => {
  return {
    placement: 'publishing',
    label: ctx.$t('privacyPolicyTitle'),
    key: 'privacy',
    disabled: {
      'publishing.relation.ref': {
        $ne: null,
      },
    },
    component: [
      {
        key: 'type',
        component: 'OptionCard',
      },

      {
        key: 'content',
        label: ctx.$t('content'),
        component: 'RichText',
      },
      {
        key: 'url',
        label: ctx.$t('redirectToExternalSite'),
        component: 'URL',
      },

      {
        key: 'alert',
        component: 'Alert',
      },
    ],

    options: {
      lockedInfo: ctx.$route.name.includes('project') ? ctx.$t('lockedInfoProjectHasPublishingReference') : '',
      collapsible: true,
      layout: 'type type type | content content content | url url url | alert alert alert',
      size: 2,

      condition: {
        alert: {
          'customFields.privacy.type': {
            $in: ['content', 'link'],
          },
        },
        content: {
          'customFields.privacy.type': 'content',
        },
        url: {
          'customFields.privacy.type': 'link',
        },
      },

      props: {
        alert: {
          label: ctx.$t('customPrivacyAlert'),
          theme: 'warning',
        },
        type: {
          default: 'default',
          header: {
            title: ctx.$t('privacyPolicyTitle'),
            icon: 'fa-pro-regular:user-pen',
            subtitle: {
              components: [
                {
                  component: 'Paragraph',
                  content: ctx.$t('privacyHeaderDescription'),
                },
              ],
            },
          },

          choices: [
            {
              title: ctx.$t('useKvassTemplate'),
              value: 'default',
              icon: 'fa-pro-regular:cards-blank',
              components: [
                {
                  component: 'Link',
                  label: ctx.$t('previewPrivacyPolicy'),
                  link: `${ctx.item.url}/legal/privacy`,
                },

                {
                  component: 'Paragraph',
                  content: ctx.$t('privacyChoiceDefaultDescription'),
                },
              ],
            },
            {
              value: 'link',
              title: ctx.$t('privacyChoiceLinkTitle'),
              icon: 'fa-pro-regular:external-link',
              components: [
                {
                  component: 'Paragraph',
                  content: ctx.$t('privacyChoiceLinkDescription'),
                },
              ],
            },
            {
              value: 'content',
              title: ctx.$t('privacyChoiceContentTitle'),
              icon: 'fa-pro-regular:pen-field',
              components: [
                {
                  component: 'Paragraph',
                  content: ctx.$t('privacyChoiceContentDescription'),
                },
              ],
            },
          ],
        },
      },
    },
  }
})

items.set('cookie', ctx => {
  const PrivacyConsents = ctx.$store.state.enums.PrivacyConsents

  const itemsComponents = [
    {
      key: 'name',
      label: ctx.$t('name'),
      component: 'Input',
    },
    {
      key: 'storagePeriod',
      label: ctx.$t('storagePeriod'),
      component: 'Input',
    },
    {
      key: 'category',
      label: ctx.$tc('category', 1),
      component: 'SelectList',
    },
    {
      key: 'description',
      label: ctx.$t('description'),
      component: 'Input',
    },
  ]

  return {
    placement: 'publishing',
    label: ctx.$t('Cookies'),
    key: 'cookie',
    disabled: {
      'publishing.relation.ref': {
        $ne: null,
      },
    },

    component: [
      {
        key: 'type',
        component: 'OptionCard',
        disabled: {
          'publishing.relation.ref': {
            $ne: null,
          },
        },
        options: {},
      },
      {
        label: `${ctx.$t('add')} ${ctx.$t('cookies')} (${ctx.$t('cookiesChoiceDefaultTitle')})`,
        isList: true,
        key: 'items',
        component: itemsComponents,
        disabled: { 'customFields.cookie.type': 'cookiebot' },
        options: {
          layout: 'name storagePeriod category | description description description',
        },
      },
    ],

    options: {
      lockedInfo: ctx.$route.name.includes('project') ? ctx.$t('lockedInfoProjectHasPublishingReference') : '',
      size: 2,
      layout: 'type | items',
      collapsible: true,
      props: {
        items: {
          category: {
            items: PrivacyConsents.map(key => ({
              value: key,
              label: `consent${key.charAt(0).toUpperCase() + key.substring(1)}Title`,
            })),
          },
        },
        type: {
          default: 'default',
          header: {
            title: 'Cookies',

            icon: 'fa-pro-regular:cookie-bite',
            subtitle: {
              components: [
                {
                  component: 'Paragraph',
                  content: ctx.$t('cookiesHeaderSubtitleP1'),
                },
                {
                  component: 'List',
                  content: ctx.$t('cookiesHeaderSubtitleList').split(','),
                },
                {
                  component: 'Paragraph',
                  content: ctx.$t('cookiesHeaderSubtitleP2'),
                },
              ],
            },
          },
          choices: [
            {
              value: 'default',
              title: ctx.$t('cookiesChoiceDefaultTitle'),
              icon: 'fa-pro-regular:objects-column',
              disabled: (ctx.$path('metadata.integrations', ctx.item) || []).includes('preset/cookiebot'),
              components: [
                {
                  component: 'Link',
                  label: ctx.$t('previewCookiePolicy'),
                  link: `${ctx.item.url}/legal/cookie`,
                },
                {
                  component: 'Paragraph',
                  content: ctx.$t('cookiesChoiceDefaultP1'),
                },

                {
                  component: 'Alert',
                  theme: 'warning',
                  content: ctx.$t('cookiesChoiceDefaultWarning'),
                  icon: 'fa-pro-regular:triangle-exclamation',
                },
                {
                  component: 'List',
                  type: 'ol',
                  content: ctx.$t('cookiesChoiceDefaultList').split(','),
                },
                {
                  component: 'Alert',
                  theme: 'primary',
                  content: ctx.$t('cookiesChoiceDefaultAlert'),
                  icon: 'fa-pro-regular:lightbulb-on',
                },
              ],
            },
            {
              value: 'cookiebot',
              title: ctx.$t('cookiesChoiceCookiebotTitle'),
              tag: ctx.$t('moreAutomated'),
              icon: 'fa-pro-light:user-robot',

              components: [
                {
                  component: 'Paragraph',
                  content: ctx.$t('integrationCookiebotDescription', { link: '' }),
                },

                {
                  component: 'Link',
                  label: ctx.$t('goToIntegration'),
                  to: {
                    name: ctx.$route.name,
                    hash: '#other',

                    params: { id: ctx.item.id, step: 'integrations' },
                  },
                },
              ],
            },
          ],
        },
      },
    },
  }
})

export default items
